import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['markPaidButton']

  enableMarkPaidButton() {
    this.markPaidButtonTarget.classList.remove("hidden")
  }
}
